import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Wallet } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/i18n/LangContext";

export const OfferCard = ({ offer, index = 0 }) => {
  const { t, l } = useLang();
  return (
  <Reveal delay={index * 0.12} className="h-full">
    <Link
      to={l(`/services/${offer.frSlug || offer.slug}`)}
      data-testid={`offer-card-${offer.frSlug || offer.slug}`}
      className="group flex h-full flex-col overflow-hidden rounded-3xl bg-white border border-ink/5 shadow-[0_20px_40px_-10px_rgba(17,14,13,0.05)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_32px_60px_-12px_rgba(17,14,13,0.12)]"
    >
      <div className="relative h-52 overflow-hidden">
        <img
          src={offer.image}
          alt={offer.imageAlt}
          loading="lazy"
          className={`h-full w-full object-cover transition-transform duration-700 group-hover:scale-105 ${offer.imgClass || ""}`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/30 to-transparent" aria-hidden="true" />
        <span className="absolute top-4 left-4 rounded-full bg-cream/90 backdrop-blur px-4 py-1.5 text-xs font-semibold text-ink">
          {t.common.offerBadge} {String(index + 1).padStart(2, "0")}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-7 md:p-8">
        <h3 className="font-display text-xl md:text-2xl font-bold tracking-tight min-h-[3.5rem] md:min-h-[4rem]">{offer.name}</h3>
        <p className="mt-3 text-sm leading-relaxed text-plum/80 flex-1">{offer.short}</p>
        <div className="mt-6 flex flex-wrap items-start gap-2 min-h-[2rem]">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-sand px-3.5 py-1.5 text-xs font-medium text-plum">
            <Clock className="w-3.5 h-3.5 text-terracotta-deep" /> {offer.duration}
          </span>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-sand px-3.5 py-1.5 text-xs font-medium text-plum">
            <Wallet className="w-3.5 h-3.5 text-terracotta-deep" /> {offer.price}
          </span>
        </div>
        <span className="mt-auto pt-7 inline-flex items-center gap-2 text-sm font-semibold text-terracotta-deep">
          {t.common.discoverOffer}
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </span>
      </div>
    </Link>
  </Reveal>
  );
};
